import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import ErrorsWarnings from "../ErrorsWarnings";
import { get } from "lodash";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";
import { FILE_UPLOAD_STATUS } from "../../utils";

const ProgressFileStatus = (props) => {
  const {
    stepperDetails,
    fileStatus,
    errorType,
    onRemove,
    warnings,
    errors,
    duplicatesCount,
    status,
    showTrash,
    menu,
  } = props;
  const [progress, setProgress] = useState();
  useEffect(() => {
    switch (status) {
      case FILE_UPLOAD_STATUS.FileUploadInProgress:
        setProgress([
          {
            count: 1,
            status: "grey",
          },
          {
            count: 2,
            status: "grey",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.ErrorCorrectionRequired:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "blue",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.CreationInProgress:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.StructuralValidationFailed:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "blue",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.SystemFailure:
        setProgress([
          {
            count: 1,
            status: "grey",
          },
          {
            count: 2,
            status: "grey",
          },
          {
            count: 3,
            status: "grey",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.PendingSubmission:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "blue",
          },
          {
            count: 4,
            status: "grey",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.AwaitingFunding:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "blue",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.AwaitingFundConfirmation:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.AwaitingTrade:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.PayrollFunded:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      case FILE_UPLOAD_STATUS.Completed:
        setProgress([
          {
            count: 1,
            status: "green",
          },
          {
            count: 2,
            status: "green",
          },
          {
            count: 3,
            status: "green",
          },
          {
            count: 4,
            status: "green",
          },
        ]);
        break;
      default:
        setProgress([]);
        break;
    }
  }, [status]);
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        {fileStatus === FILE_UPLOAD_STATUS.Cancelled ? (
          ""
        ) : fileStatus === FILE_UPLOAD_STATUS.Deleted ? (
          ""
        ) : (
          <div className="ft-12 black-text">
            <ul className="progress-status">
              Progress:
              {progress ? (
                progress.map((data, index) => (
                  <li
                    className={
                      data.count === status
                        ? "progress-active"
                        : data.status === "green"
                        ? "awaiting-bg"
                        : data.status === "blue"
                        ? "awaiting-blue"
                        : ""
                    }
                  >
                    {data.count}
                  </li>
                ))
              ) : (
                <span> No data</span>
              )}
            </ul>
          </div>
        )}
        {fileStatus === FILE_UPLOAD_STATUS.Cancelled ? (
          ""
        ) : fileStatus === FILE_UPLOAD_STATUS.Deleted ? (
          ""
        ) : (
          <div>
            {showTrash
              ? permissions[roleName].menuItems[menu].includes("D") && (
                  <div onClick={onRemove}>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      size="13px"
                      color="#FF0000"
                    />
                  </div>
                )
              : null}
          </div>
        )}
      </div>
      <div>
        <p className="ft-12 font-weight-500 mt-10 mb-10 text-black">
          Status :{" "}
          {fileStatus === FILE_UPLOAD_STATUS.FileUploadInProgress ? (
            <span className="inprogress-text">File upload in progress</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.ErrorCorrectionRequired ? (
            <span className="error-text">Error Corrections required</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.StructuralValidationFailed ? (
            <span className="error-text">Error in File Processor</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.SystemFailure ? (
            <span className="error-text">System Failure</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.PendingSubmission ? (
            <span className="pending-text">Pending Submission</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.AwaitingFunding ? (
            <span className="awaiting-text">Awaiting funding</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.CreationInProgress ? (
            <span className="creation-text">Creation in progress</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.Cancelled ? (
            <span className="cancelled-text">Cancelled</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.Deleted ? (
            "Deleted"
          ) : fileStatus === FILE_UPLOAD_STATUS.AwaitingTrade ? (
            <span className="awaiting-text">Awaiting Trade</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.AwaitingFundConfirmation ? (
            <span className="awaiting-text">Awaiting Fund Confirmation</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.PayrollFunded ? (
            <span className="awaiting-text">Payroll Funded</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.Completed ? (
            <span className="awaiting-text">Completed</span>
          ) : fileStatus === FILE_UPLOAD_STATUS.PayrollFundingInProgress ? (
            <span className="pending-text">Final submit in progress</span>
          ) : null}
        </p>
      </div>
      <div>
        <p className="ft-12 black-text font-weight-500 mb-10">
          {errorType === 2 ? (
            <span>
              <span className="error-text ft-14">{duplicatesCount}</span>{" "}
              Duplicates founds
            </span>
          ) : errorType === 3 &&
            (fileStatus === FILE_UPLOAD_STATUS.ErrorCorrectionRequired ||
              fileStatus === FILE_UPLOAD_STATUS.PendingSubmission) ? (
            <ErrorsWarnings errors={errors} warnings={warnings} />
          ) : null}
        </p>
      </div>
    </>
  );
};

export default ProgressFileStatus;
